// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Control_wrapper__wTGIF","symbol":"Control_symbol__ouMSK","number-plate":"Control_number-plate__smldw","errorMessage":"Control_errorMessage__glRRp"};